import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { motionOk } from "../lib/motionOk.js";
import { useLang } from "../i18n.jsx";

export default function Roadmap() {
  const { content } = useLang();
  const { roadmap } = content;
  return (
    <section id="proses" className="relative px-6 py-20 overflow-hidden">
      <div className="pointer-events-none absolute -top-10 left-0 w-[420px] h-[420px] rounded-full bg-acid/[0.04] blur-3xl" />
      <div className="relative mx-auto max-w-6xl">
        <motion.div
          initial={motionOk ? { opacity: 0, y: 24 } : false}
          whileInView={motionOk ? { opacity: 1, y: 0 } : undefined}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-2xl"
        >
          <p className="mb-4 text-xs uppercase tracking-[0.3em] text-acid">{roadmap.head.eyebrow}</p>
          <h2 className="font-display font-extrabold tracking-tight text-[clamp(1.8rem,4.2vw,3.2rem)] leading-[1.08] text-paper">
            {roadmap.head.titleA}
            <span className="block">{roadmap.head.titleB}</span>
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-paper/70">{roadmap.head.sub}</p>
        </motion.div>

        <div className="relative mt-14">
          <svg
            className="af-roadmap-svg hidden lg:block absolute top-7 left-0 right-0 w-full text-acid"
            viewBox="0 0 1000 2"
            preserveAspectRatio="none"
            height="2"
            aria-hidden="true"
          >
            <path className="af-roadmap-line" d="M0 1 H1000" stroke="currentColor" strokeOpacity="0.55" strokeWidth="2" fill="none" />
          </svg>
          <ol className="grid gap-8 sm:grid-cols-2 lg:grid-cols-6 lg:gap-0">
            {roadmap.steps.map((s, i) => (
              <motion.li
                key={s.num}
                initial={motionOk ? { opacity: 0, y: 26 } : false}
                whileInView={motionOk ? { opacity: 1, y: 0 } : undefined}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ delay: i * 0.08, duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
                className="lg:px-3"
              >
                <div className="flex items-center gap-3 lg:flex-col lg:items-center lg:gap-0 lg:text-center">
                  <div className="relative z-10 grid place-items-center w-14 h-14 shrink-0 rounded-2xl border border-acid/40 bg-ink2 font-display text-base font-extrabold text-acid shadow-lg shadow-black/30">
                    {s.num}
                  </div>
                  <div className="lg:mt-4">
                    <h3 className="font-display text-[15px] font-bold tracking-tight text-paper">{s.title}</h3>
                    <p className="mt-1 text-sm text-paper/60 leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              </motion.li>
            ))}
          </ol>
        </div>

        <motion.div
          initial={motionOk ? { opacity: 0, y: 14 } : false}
          whileInView={motionOk ? { opacity: 1, y: 0 } : undefined}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-3 rounded-2xl border border-paper/10 bg-ink2/40 px-6 py-4 text-sm text-paper/75"
        >
          <span className="grid place-items-center w-7 h-7 rounded-full bg-acid text-ink"><Check className="w-4 h-4" /></span>
          <span className="text-center sm:text-left">{roadmap.note}</span>
        </motion.div>
      </div>
    </section>
  );
}
